// Activation Pro connect en attente (page /activer).
//
// Le QR de l'appareil converti porte /activer?sn=<CA...>&t=<jeton>. Si le client
// n'est pas connecte, il passe par la connexion ou la creation de compte ; la
// creation exige de cliquer le lien du courriel de confirmation, qui s'ouvre
// souvent dans un AUTRE onglet (sessionStorage perdu). On garde donc sn et t dans
// localStorage 48 h au plus, sur CE telephone seulement, et on les efface des que
// le rattachement a reussi. Le jeton n'est jamais envoye ailleurs qu'a claimDevice.
const CLE = "activationProConnect";
const DUREE_MS = 48 * 3600 * 1000;

export const JETON_RE = /^[0-9a-fA-F]{32,128}$/;
export const SERIE_PROCONNECT_RE = /^C[A-Z][0-9]{8}$/;

export function lireActivation() {
  try {
    const brut = window.localStorage.getItem(CLE);
    if (!brut) return null;
    const a = JSON.parse(brut);
    if (!a || typeof a !== "object" || !a.at || Date.now() - a.at > DUREE_MS) {
      window.localStorage.removeItem(CLE);
      return null;
    }
    return { sn: typeof a.sn === "string" ? a.sn : "", t: typeof a.t === "string" ? a.t : "" };
  } catch (e) {
    return null;
  }
}

export function sauverActivation(sn, t) {
  const a = { sn: (sn || "").trim().toUpperCase().slice(0, 64), t: (t || "").trim().slice(0, 128), at: Date.now() };
  try { window.localStorage.setItem(CLE, JSON.stringify(a)); } catch (e) { /* navigation privee : sans memoire */ }
  return { sn: a.sn, t: a.t };
}

export function effacerActivation() {
  try { window.localStorage.removeItem(CLE); } catch (e) { /* rien */ }
}

// Session academie : { user_id, email, first_name, token, ... } ou null.
export function sessionAcademie() {
  try {
    const u = JSON.parse(sessionStorage.getItem("userData") || "null");
    return u && typeof u === "object" && u.token ? u : null;
  } catch (e) {
    return null;
  }
}
